import { Navigate } from 'react-router';
import { routePaths } from './routes';

export function RootEmpty() {
  return <Navigate to={routePaths.app} />;
}
